module.exports = __webpack_public_path__ + "static/media/lend.5febe013.png";